import i18n from '@/locale/i18n'

import other1 from '@/page/other/other1'
import other2 from '@/page/other/other2'
import other3 from '@/page/other/other3'
import topUp from '@/page/other/topUp'
import awardPoints from '@/page/other/awardPoints'
export default [
    {
        path: '/other/other1',
        component: other1,
        meta: { title: '' }
    },
    {
        path: '/other/other2',
        component: other2,
        meta: { title: ''}
    },
    {
        path: '/other/other3',
        component: other3,
        meta: { title: ''}
    },
    {
        path: '/other/topUp',
        component: topUp,
        meta: { title: ''}
    },
    {
        path: '/other/awardPoints',
        component: awardPoints,
        meta: { title: ''}
    }
]



// WEBPACK FOOTER //
// ./src/router/other/index.js